import React, { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';
import api from '../api/client';

export default function RelatedReading({ categories = [], limit = 4 }) {
  const [data, setData] = useState(null);
  const key = categories.join(',');

  useEffect(() => {
    api.get('/aj-articles', { params: { categories: key, limit } }).then(r => setData(r.data)).catch(() => setData(null));
  }, [key, limit]);

  if (!data || (!data.items.length && !data.categoryLinks.length)) return null;

  return (
    <section className="aj-edition bg-[#f7fafb] rounded-r-[10px] p-5" aria-labelledby="related-reading-title" data-testid="related-reading">
      <span className="aj-kicker">Leia no Âmbito Jurídico</span>
      <h3 id="related-reading-title" className="text-[20px] leading-[1.35] mt-1 mb-3">Entenda seus direitos antes da consulta.</h3>
      {data.items.length > 0 && (
        <ul className="m-0 p-0 list-none divide-y divide-[#e1e9eb]">
          {data.items.map(a => (
            <li key={a.url} className="py-2.5">
              <a href={a.url} target="_blank" rel="noopener" className="text-[16px] font-semibold text-[#075a6d] hover:text-[#063f4c] underline underline-offset-[0.18em] decoration-[0.075em]" data-testid="related-reading-link">{a.title}</a>
              <div className="text-[13px] text-[#52676e] mt-0.5">{a.categoryName}</div>
            </li>
          ))}
        </ul>
      )}
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-3">
        {data.categoryLinks.slice(0, 3).map(c => (
          <a key={c.slug} href={c.url} target="_blank" rel="noopener" className="inline-flex items-center gap-1 text-[14px] font-semibold text-[#075a6d] hover:text-[#063f4c] underline underline-offset-[0.18em]">
            Mais sobre {c.name} <ExternalLink className="w-3 h-3" aria-hidden="true" />
          </a>
        ))}
      </div>
    </section>
  );
}
